// eslint-disable-next-line import/prefer-default-export
export const insuredTypeOptions = [
  { label: 'Gama', value: 'gamma' },
  { label: 'Delta', value: 'delta' }
];
